import { Badge } from "@abb/arcadia-ui-react"
import { useFeedbacks } from "../../../../hooks/useFeedbacks"
import { FeedbackGet } from "../../../models/Feedback"
import {
  dateStringComparator,
  getNiceFormattedDate,
} from "../../../utils/getFormattedDate"
import { EntityRow, EntityTab } from "../../partials/EntityTab"

export function Feedbacks() {
  const { feedbacksList, isLoadingFeedbacks } = useFeedbacks()

  const cols = [
    {
      field: "username",
      headerName: "Username",
      isLink: true,
      linkBasePath: "/feedbacks",
    },
    { field: "applicationShortName", headerName: "Application" },
    { field: "topic", headerName: "Topic" },
    { field: "description", headerName: "Description" },
    {
      field: "creationDate",
      headerName: "Creation date",
      sortComparator: dateStringComparator,
    },
    {
      field: "status",
      headerName: "Status",
      renderCell: (row: EntityRow) =>
        row.status === "Completed" ? (
          <Badge label="Completed" status="positive" variant="outlined-square-badge" />
        ) : (
          <Badge label="Open" status="negative" variant="outlined-square-badge" />
        ),
    },
  ]

  const sorted = [...feedbacksList].sort(
    (a, b) =>
      new Date(b.creationDate ?? 0).getTime() - new Date(a.creationDate ?? 0).getTime()
  )

  const rows = sorted.map((feedback: FeedbackGet) => ({
    id: feedback.id,
    username: feedback.user.username,
    applicationShortName: feedback.application.shortName,
    topic: feedback.topic.name,
    description: feedback.description,
    creationDate: getNiceFormattedDate(feedback.creationDate),
    status: feedback.completionDate ? "Completed" : "Open",
  }))

  return <EntityTab rows={rows} cols={cols} isLoading={isLoadingFeedbacks} />
}
